const SEX_CONFIGS = {
  M: {
    slug: 'boy',
  },
  F: {
    slug: 'girl',
  },
}

const ALPHABET = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
]

module.exports = { SEX_CONFIGS, ALPHABET }
